/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AutomatedReportScheduleViewModel { 
    id?: string;
    orgId?: number;
    name?: string | null;
    cronExpression?: string | null;
    groupIds?: Array<number> | null;
    extraRecipients?: Array<string> | null;
    reportDays?: number;
    isActive?: boolean;
}

